export default function miseAJourListeIntervenants(value, intervenants) {
  intervenants.splice(intervenants.indexOf(value.initial), 1, value.modifier);
  return intervenants;
}
